import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// CRITICAL: Preconnect + preload hero image BEFORE React renders
// This makes the LCP image discoverable from the initial document
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
document.head.appendChild(preconnect);
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.href = 'https://cdn.magicpatterns.com/uploads/vyhkFtBTZm9HP3SdiyttFd/PASO_A_PASO_Protocolos_con_instructiones_exactas_y_diagramas.png';
preload.setAttribute('fetchpriority', 'high');
document.head.appendChild(preload);
render(<App data-id="element-3" />, document.getElementById('root'));